import {
  Box,
  Button,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { CDN_PATH } from 'src/constants/global'
import styles from './BaseDialog.scss'

interface BaseDialogHeaderProps {
  closeDisabled?: boolean
  isFullScreen?: boolean
  isLmnDialog?: boolean
  loading?: boolean
  onClose: (event?: object, reason?: string) => void
}

const BaseDialogHeader = ({
  closeDisabled,
  isFullScreen,
  isLmnDialog,
  loading,
  onClose,
}: BaseDialogHeaderProps): JSX.Element => {
  const { breakpoints, palette } = useTheme()
  const isSmallViewport = useMediaQuery(breakpoints.down('sm'))

  return (
    <>
      {isFullScreen && !loading ? (
        <DialogTitle
          sx={{
            padding: isSmallViewport ? '0px 8px' : '8px',
            borderBottom: `1px solid ${palette.gray3.main}`,
          }}
        >
          <Box className={styles.baseDialogHeaderContainer}>
            <Box className={styles.baseDialogHeaderContainerCenter} width={isSmallViewport ? '100%' : '457px'}>
              <Box className={styles.baseDialogHeaderPoweredByAndCloseContainer}>
                <Button
                  color="primary"
                  variant="text"
                  disabled={closeDisabled}
                  onClick={onClose}
                >
                  <Typography variant="body3" fontWeight="regular" color="primary.main">
                    {isLmnDialog ? '← Exit' : '← Back to cart'}
                  </Typography>
                </Button>
                <Box className={styles.baseDialogHeaderPoweredByContainer}>
                  <Typography variant="body3" fontWeight="regular" className={styles.baseDialogHeaderPoweredBy} color="primary.main">
                    Powered by
                  </Typography>
                  <img src={`${CDN_PATH}/images/sika-logo-black.svg`} alt="Sika" />
                </Box>
              </Box>
            </Box>
          </Box>
        </DialogTitle>
      ) : null }
      {!isFullScreen ? (
        <DialogTitle sx={{ padding: '0px 8px', borderBottom: `1px solid ${palette.gray3.main}` }}>
          <Box className={styles.baseDialogHeaderPoweredByAndCloseContainer}>
            <Box className={styles.baseDialogHeaderPoweredByContainer}>
              <Typography
                className={styles.baseDialogHeaderPoweredBy}
                variant="body3"
                fontWeight="regular"
                color="gray1.main"
              >
                Powered by
              </Typography>
              <img src={`${CDN_PATH}/images/sika-logo-gray1.svg`} alt="Sika" />
            </Box>
            <IconButton
              aria-label="close"
              disabled={closeDisabled}
              onClick={onClose}
              sx={{ color: `${palette.gray1.main} !important` }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
      ) : null }
    </>
  )
}

export default BaseDialogHeader
